import React from "react";
import { useTranslation } from "react-i18next";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";

export const TaxFields = ({
    dto,
    errorInputs,
    taxesSiigo,
    configuration,
    handleInputChange,
}) => {
    const { t } = useTranslation();
    const isSiigo = configuration?.ERP === "siigo";

    return (
        <>
            <Grid size={{ xs: 12, sm: 6 }}>
                {isSiigo ? (
                    <FormControl fullWidth size="small">
                        <InputLabel>{t("crm.products.account_tax_iva")}</InputLabel>
                        <Select
                            label={t("crm.products.account_tax_iva")}
                            name="account_tax_iva"
                            value={dto.account_tax_iva}
                            onChange={handleInputChange}
                        >
                            {taxesSiigo.map((cat) => (
                                <MenuItem key={cat.code} value={cat.code}>{cat.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                ) : (
                    <TextField
                        fullWidth
                        size="small"
                        label={t("crm.products.account_tax_iva")}
                        name="account_tax_iva"
                        value={dto.account_tax_iva}
                        onChange={handleInputChange}
                    />
                )}
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                    fullWidth
                    size="small"
                    label={t("crm.products.account_discount")}
                    name="account_discount"
                    value={dto.account_discount}
                    onChange={handleInputChange}
                    error={Boolean(errorInputs.account_discount?.isError)}
                    helperText={errorInputs.account_discount?.messageError ?? ""}
                />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                    fullWidth
                    size="small"
                    label={t("crm.products.account_tax_others")}
                    name="account_tax_others"
                    value={dto.account_tax_others}
                    onChange={handleInputChange}
                />
            </Grid>
        </>
    );
};